import { createSlice } from "@reduxjs/toolkit";
import { createCustomer } from "../thunks/createCustomerThunk";

const createCustomerSlice = createSlice({
  name: "customer",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    customer: null,
  },
  reducers: {
    resetCreateCustomerStatus: (state) => {
      state.status = "idle";
      state.error = null;
      state.customer = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCustomer.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.customer = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(createCustomer.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetCreateCustomerStatus } = createCustomerSlice.actions;
export default createCustomerSlice.reducer;
